import { esMarcaPersonalPalettes } from "../../../../Posts/05-tematicas/09-marca-personal/personalBrandPalettes.js";
import { localizeTematicPalettes } from "../../../../src/helpers/localizeTematicPalettes.js";
import * as React from 'react';
export default {
  esMarcaPersonalPalettes,
  localizeTematicPalettes,
  React
};